<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300"
	><style>
		.st0 {
			fill: #dcf1ff;
		}

		.st2 {
			fill: #e8be62;
		}

		.st3 {
			fill: #fff;
		}

		.st4 {
			fill: #b2bad1;
		}

		.st5,
		.st6 {
			stroke-linecap: round;
			stroke-dasharray: 0, 2, 40, 2;
			stroke: #b2bad1;
			fill: none;
			stroke-miterlimit: 10;
		}

		.st6 {
			stroke-linejoin: round;
		}
	</style><path
		class="st0"
		d="M166.8 182.8c-27.8-.5-55.4 5.8-83.2 5.6-6.8-.1-13.9-.6-19.7-4.2-11-6.7-13.5-21.5-13.8-34.4-.7-30.5 5.1-62.1 22.1-87.4s46.7-43.4 77.2-41.2c27 1.9 51.2 19.1 67 41s24.4 48.2 30.9 74.5c4.8 19.3 8.6 39.2 6 58.9-3.9 29.6-17.3 12-31.2 2.6-16.1-10.9-36.3-15-55.3-15.4z"
	/><path
		fill="#ebeef2"
		d="M59.9 251.8l14.5-12.2 6.7 2.2 13.3-23.4 5.6-1.1 10-11.1 57.6 15.5 25.9-8.9 12.2 11.2 5.6-1.1 13.3 17.8 14.5 11.1z"
	/><path
		class="st2"
		d="M170.5 91.5c0-11.1-18.2-20.2-21.5-21.8-.3-.2-.7-.2-1 0-3.3 1.6-21.5 10.7-21.5 21.8h44z"
	/><path class="st3" d="M131 90h36v29h-36z" /><path
		class="st4"
		d="M166.3 94.5h-34.6c-.7 0-1.2-.5-1.2-1.2v-.1c0-.7.5-1.2 1.2-1.2h34.6c.7 0 1.2.5 1.2 1.2v.1c0 .6-.5 1.2-1.2 1.2z"
	/><path
		class="st3"
		d="M171.3 90h-44.6c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h44.6c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2zM169.2 121.5h-41.5l-4.2 109h50z"
	/><path
		class="st4"
		d="M170.3 124.5h-42.6c-.7 0-1.2-.5-1.2-1.2v-.1c0-.7.5-1.2 1.2-1.2h42.6c.7 0 1.2.5 1.2 1.2v.1c0 .6-.5 1.2-1.2 1.2z"
	/><path
		class="st3"
		d="M171.3 120h-44.6c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h44.6c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2zM191 230.5h-83l-3 20h89z"
	/><path
		class="st4"
		d="M162.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM154 248h-10v-9c0-2.8 2.2-5 5-5s5 2.2 5 5v9zM172.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM182.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM115.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM125.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM135.5 245c-.8 0-1.5-.7-1.5-1.5v-4c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v4c0 .8-.7 1.5-1.5 1.5zM154 149h-10v-9c0-2.8 2.2-5 5-5s5 2.2 5 5v9z"
	/><path class="st2" d="M113.4 226.5h72.2c3.4 0 6.5 1.7 8.4 4.5h-89c1.9-2.8 5-4.5 8.4-4.5z" /><path
		class="st4"
		d="M154 184h-10v-9c0-2.8 2.2-5 5-5s5 2.2 5 5v9zM154 219h-10v-9c0-2.8 2.2-5 5-5s5 2.2 5 5v9zM170.6 160.5h-44.2c-.7 0-1.2-.5-1.2-1.2v-.1c0-.7.5-1.2 1.2-1.2h44.2c.7 0 1.2.5 1.2 1.2v.1c0 .6-.5 1.2-1.2 1.2zM171.9 196.5h-46.8c-.7 0-1.2-.5-1.2-1.2v-.1c0-.7.5-1.2 1.2-1.2h46.8c.7 0 1.2.5 1.2 1.2v.1c0 .6-.6 1.2-1.2 1.2z"
	/><path
		class="st0"
		d="M137.8 110.5h-2.6c-1.2 0-2.2-1-2.2-2.2v-8.6c0-1.2 1-2.2 2.2-2.2h2.6c1.2 0 2.2 1 2.2 2.2v8.6c0 1.2-1 2.2-2.2 2.2zM153.3 110.5h-8.6c-1.2 0-2.2-1-2.2-2.2v-8.6c0-1.2 1-2.2 2.2-2.2h8.6c1.2 0 2.2 1 2.2 2.2v8.6c0 1.2-1 2.2-2.2 2.2zM162.8 110.5h-2.6c-1.2 0-2.2-1-2.2-2.2v-8.6c0-1.2 1-2.2 2.2-2.2h2.6c1.2 0 2.2 1 2.2 2.2v8.6c0 1.2-1 2.2-2.2 2.2z"
	/><g
		><path
			class="st4"
			d="M171.3 118h-44.6c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2h44.6c.7 0 1.2-.5 1.2-1.2s-.5-1.2-1.2-1.2zM172 114.5h-46c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h46c.3 0 .5.2.5.5s-.2.5-.5.5z"
		/><path transform="rotate(-90 129.002 116.482)" class="st4" d="M127 116h4v1h-4z" /><path
			transform="rotate(-90 139.002 116.482)"
			class="st4"
			d="M137 116h4v1h-4z"
		/><path transform="rotate(-90 149.002 116.482)" class="st4" d="M147 116h4v1h-4z" /><path
			transform="rotate(-90 159.002 116.482)"
			class="st4"
			d="M157 116h4v1h-4z"
		/><path transform="rotate(-90 169.002 116.482)" class="st4" d="M167 116h4v1h-4z" /></g
	><path
		class="st4"
		d="M148 68.7c.3-.1.6-.1.9 0 .1.1.3.2.5.3v-3c0-.6-.4-1-1-1s-1 .4-1 1v3c.3-.1.5-.2.6-.3z"
	/><path
		class="st3"
		d="M71.9 146.6c4.5 0 8.1-3.6 8.1-8.1s-3.6-8.1-8.1-8.1c-1 0-2 .2-2.9.6-1.7-4.3-5.9-7.4-10.8-7.4-6.4 0-11.6 5.2-11.6 11.6v.2c-.8-.4-1.7-.6-2.6-.6-3.3 0-6 2.7-6 6s2.7 6 6 6h27.9zM199.3 70.5c-3.5 0-6.4-2.9-6.4-6.4 0-3.5 2.9-6.4 6.4-6.4.8 0 1.6.2 2.3.4 1.3-3.4 4.6-5.8 8.4-5.8 5 0 9.1 4.1 9.1 9.1v.1c.6-.3 1.3-.5 2-.5 2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7h-21.8z"
	/><path
		class="st5"
		d="M78.8 279c2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7M149 267c2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7M52.4 267c2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7"
	/><path
		class="st4"
		d="M34.8 254.1c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7 2.3 0 4.5-.6 6.4-1.7 1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c1.9 1.1 4 1.7 6.4 1.7s4.5-.6 6.4-1.7c.1 0 .2.1.2.1-.7-2.2-2.7-3.7-5.1-3.7H39.7c-2.4 0-4.4 1.6-5.1 3.7.1 0 .2-.1.2-.1z"
	/><path
		class="st6"
		d="M162.4 106.1l45.8 15.4M208.2 87l-45.8 15.6M136 106.1l-45.8 15.4M90.2 87l45.8 15.6"
	/><path
		class="st3"
		d="M227.5 166.7c2.4 0 4.4-2 4.4-4.4 0-2.4-2-4.4-4.4-4.4-.6 0-1.1.1-1.6.3-.9-2.3-3.1-4-5.8-4-3.4 0-6.2 2.8-6.2 6.2v.1c-.4-.2-.9-.3-1.4-.3-1.8 0-3.2 1.4-3.2 3.2 0 1.8 1.4 3.2 3.2 3.2h15z"
	/><path class="st6" d="M174 104h25.7M123.7 104H98" /></svg
>
